import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  areYouSure: {
    defaultMessage: 'Are you sure you want to do this?',
    id: 'dclZr/',
  },
  no: {
    defaultMessage: 'No',
    id: 'oUWADl',
  },
  yes: {
    defaultMessage: 'Yes',
    id: 'a5msuh',
  },
  deletedSuccessfully: {
    defaultMessage: 'Deleted successfully',
    id: 'cpe3Tc',
  },
});
